import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from 'src/components/Octopath/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Battle = makeShortcode("Battle");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Throne Single Story" mdxType="SEO" />
    <p>{`This route relies on getting at least EXP x5 on BG Assassins.`}</p>
    <p>{`Start Throne`}</p>
    <h3 {...{
      "id": "new-delsta-throne-1"
    }}>{`New Delsta (Throne 1)`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "pursuers-1"
      }}>{`Pursuers 1`}</h4>
      <h5 {...{
        "id": "turn-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`C1: Attack`}</li>
        <li parentName="ul">{`C2: Attack x2 Pursuer 2`}</li>
        <li parentName="ul">{`C3: Attack Pursuer 1`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`C1&C3: Attack x3 each Pursuer`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "pursuers-2"
      }}>{`Pursuers 2`}</h4>
      <h5 {...{
        "id": "turn-1-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Darkest Night #1 (Front)	`}</li>
        <li parentName="ul">{`Pirro: Pierce Through Leader	`}</li>
        <li parentName="ul">{`Scaracci:	Attack #2 (Back)	`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-1"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Darkest Night x3 Leader	`}</li>
        <li parentName="ul">{`Pirro: Slice x3 #2 (Back)	`}</li>
        <li parentName="ul">{`Scaracci: Axe x3 #1 (Front)	`}</li>
      </ul>
    </Battle>
    <p>{`Continue with the story until after the day cutscene with Father.						`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Brothel Girl's Clothes`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Gold Ring`}</strong>{` from Brothel Receptionist.`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Shadow Soulstone`}</strong>{`.`}</p>
    <p>{`Steal `}<strong parentName="p">{`Ice, Wind, Light Soulstone`}</strong>{` from Artist.`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Antique Coin`}</strong>{`.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "pirro-2100hp-5s-swordlightshadow"
      }}>{`Pirro 2100HP 5S (Sword,Light,Shadow)`}</h4>
      <ol>
        <li parentName="ol">{`Darkest Night`}</li>
        <li parentName="ol">{`Darkest Night`}</li>
        <li parentName="ol">{`Darkest Night x4`}</li>
        <li parentName="ol">{`Sword`}</li>
        <li parentName="ol">{`Sword (break)`}</li>
        <li parentName="ol">{`Shadow Soulstone`}</li>
        <li parentName="ol">{`(Healing Grape if after Pirro next turn)`}</li>
        <li parentName="ol">{`Light Soulstone`}</li>
        <li parentName="ol">{`Sword x4 (break)`}</li>
        <li parentName="ol">{`[LP]`}{` Wind Soulstone, Ice Soulstone`}</li>
        <li parentName="ol">{`Sword`}</li>
      </ol>
    </Battle>
    <p>{`Tag `}<strong parentName="p">{`New Delsta Anchorage`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Herb of Serenity`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you get Concoct Materials at Black Market, buy 1 Lily 2 Darkdelions`}</p>
    </blockquote>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Antique Coin`}</li>
        <li parentName="ul">{`Gold Ring`}</li>
        <li parentName="ul">{`Herb of Serenity`}</li>
        <li parentName="ul">{`Inspirating Plum Basket`}</li>
      </ul>
      <h5 {...{
        "id": "buy"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`1 Ice S`}</li>
        <li parentName="ul">{`4 Shadow M`}</li>
      </ul>
    </Menu>
    <p>{`Go towards `}<strong parentName="p">{`Cape Cold`}</strong>{`, get `}<strong parentName="p">{`Osvald`}</strong>{`. Can force battle before getting him.`}</p>
    <blockquote>
      <h5 parentName="blockquote" {...{
        "id": "puff-and-cait-kills"
      }}>{`Puff and Cait Kills`}</h5>
      <p parentName="blockquote">{`These all assume Untouched Bonus`}<br parentName="p"></br>{`
`}{`Cait's can Steal Dazzling + Stimulating instead of Mug`}</p>
      <ul parentName="blockquote">
        <li parentName="ul"><strong parentName="li">{`Cait`}</strong>{`: Skip Bottle Quest, Steal Complex Tome. Money is very tight post Assassins.`}</li>
        <li parentName="ul"><strong parentName="li">{`Puff`}</strong>{`: Can skip $1600 chest or buy an extra M Stone`}</li>
        <li parentName="ul"><strong parentName="li">{`Cultured Cait`}</strong>{`: Skip Bottle Quest, Magus Knife, Soldier's Bow, Sailor's Vest. If 2nd battle, buy Wind M and sell Sailor's Vest`}</li>
        <li parentName="ul"><strong parentName="li">{`Queen Puff`}</strong>{`: Same as Cait. If it was 1st battle, skip Wind M purchase and Complex Tome Steal`}</li>
      </ul>
    </blockquote>
    <p>{`Go to `}<strong parentName="p">{`Western Winterbloom Snows`}</strong>{`.`}</p>
    <p>{`Kill battle with `}<strong parentName="p">{`Shadow M`}</strong>{`. `}</p>
    <blockquote>
      <p parentName="blockquote">{`Take note if you get a Lily of the Light from either battle.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`Highly recommended to reset steps and get a autosave at Scholar Shrine. If not, 30% chance that you get a battle that won't get you enough JP. 70% chance you won't get enough if you get Ambushed once.`}</p>
    </blockquote>
    <p>{`Kill a 2nd battle with `}<strong parentName="p">{`Shadow M`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "learn-skills"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Throne: +Armor Corrosive`}</li>
        <li parentName="ul">{`Osvald: +Lightning Bolt +Analyze`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: +`}{`[1]`}{`Evasive Maneuvers`}</li>
      </ul>
    </Menu>
    <p>{`Enter `}<strong parentName="p">{`Winterbloom`}</strong>{`.`}</p>
    <h3 {...{
      "id": "winterbloom"
    }}>{`Winterbloom`}</h3>
    <p>{`Don't start Throne Ch.2. TP `}<strong parentName="p">{`New Delsta: Anchorage`}</strong>{`.`}</p>
    <p>{`Take boat to `}<strong parentName="p">{`Crackridge Anchorage`}</strong>{`. Head to `}<strong parentName="p">{`Oresrush`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$1600`}</strong>{`.`}</p>
    <h3 {...{
      "id": "oresrush"
    }}>{`Oresrush`}</h3>
    <p>{`Start Throne Ch.2. Recruit `}<strong parentName="p">{`Partitio`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`New Delsta Anchorage`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Take boat to `}<strong parentName="p">{`Beasting Bay Anchorage`}</strong>{`.`}</p>
    <h3 {...{
      "id": "beasting-bay-anchorage"
    }}>{`Beasting Bay Anchorage`}</h3>
    <p>{`Steal `}<strong parentName="p">{`Bottle of White Powder`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Take boat to `}<strong parentName="p">{`Canalbrine`}</strong>{`.`}</p>
    <h3 {...{
      "id": "canalbrine"
    }}>{`Canalbrine`}</h3>
    <p>{`Steal `}<strong parentName="p">{`Fire S & Thunder S`}</strong>{`. `}</p>
    <blockquote>
      <p parentName="blockquote">{`If you fail, you can Steal a Fire S in Oresrush and a Thunder S in Wellgrove Dancer Guild`}</p>
    </blockquote>
    <p>{`Recruit `}<strong parentName="p">{`Castti`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Turn in `}<strong parentName="p">{`Bottle Quest`}</strong>{`. Steal `}<strong parentName="p">{`Forget-me-do`}</strong>{`, purchase `}<strong parentName="p">{`Wind M`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Weapon Shop`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h3 {...{
        "id": "buy-1"
      }}>{`Buy`}</h3>
      <ul>
        <li parentName="ul">{`Critical Earring`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Oresrush`}</strong>{`, head to `}<strong parentName="p">{`Wellgrove`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Icicle doesn't do enough damage, need other 3 characters to use Skill`}</p>
    </blockquote>
    <p><em parentName="p">{`Check to see if you get a `}<strong parentName="em">{`Forget-me-do`}</strong>{` drop from these fights`}</em><br parentName="p"></br>{`
`}{`Northern Wellgrove Trail: Pick `}<strong parentName="p">{`Wind M`}</strong>{`. Kill battle with Shadow M + Skill x2. Pick `}<strong parentName="p">{`Pom L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Eastern Wellgrove Trail: Pick `}<strong parentName="p">{`Magus Knife`}</strong>{`. Kill battle with Shadow M + Skill x2.`}</p>
    <h3 {...{
      "id": "wellgrove"
    }}>{`Wellgrove`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Soldier's Bow`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Get `}<strong parentName="p">{`Dancer License`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Oresrush`}</strong>{`.`}</p>
    <h3 {...{
      "id": "oresrush-1"
    }}>{`Oresrush`}</h3>
    <p>{`Steal `}<strong parentName="p">{`Fire S`}</strong>{`. Steal `}<strong parentName="p">{`Unerring Earring`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Hire `}<strong parentName="p">{`Smooth Talker`}</strong>{`.`}<br parentName="p"></br>{`
`}{`If no drops, steal `}<strong parentName="p">{`Forget-me-do`}</strong>{` from guy in Weapon Shop.`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Horse Coin`}</strong>{`. `}</p>
    <blockquote>
      <p parentName="blockquote">{`This can be skipped if you bought Darkdelions at Black Market`}</p>
    </blockquote>
    <p>{`Go to `}<strong parentName="p">{`Item Shop`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h3 {...{
        "id": "buy-2"
      }}>{`Buy`}</h3>
      <ul>
        <li parentName="ul">{`2 Darkdelion`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`The sell here isn't needed, can be done later. Benefit of doing it now is having HHG for potential Cultured Cait at Borderfall.`}</p>
      </blockquote>
      <h3 {...{
        "id": "sell-1"
      }}>{`Sell`}</h3>
      <ul>
        <li parentName="ul">{`Soldier's Bow`}</li>
        <li parentName="ul">{`Magus Knife`}</li>
      </ul>
    </Menu>
    <p>{`Finish Throne Ch.2`}</p>
    <p>{`TP `}<strong parentName="p">{`Canalbrine`}</strong>{`, head to `}<strong parentName="p">{`Conning Creek`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Kill both night battles on Conning screens with Wind M.`}</p>
    <h3 {...{
      "id": "conning-creek"
    }}>{`Conning Creek`}</h3>
    <p>{`Steal `}<strong parentName="p">{`Sailor's Vest, Octopuff Pot`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`With standard money the Sailor's Vest isn't necessary.`}</p>
    </blockquote>
    <p>{`Steal `}<strong parentName="p">{`Wind L, Pom M`}</strong>{`. Pick `}<strong parentName="p">{`Rainbow Glass Bottle`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`New Delsta`}</strong>{`.`}</p>
    <h3 {...{
      "id": "new-delsta"
    }}>{`New Delsta`}</h3>
    <p>{`Go to `}<strong parentName="p">{`Inventor`}</strong>{`, get Inventor + upgrades.`}<br parentName="p"></br>{`
`}{`Head to `}<strong parentName="p">{`Montwise`}</strong>{`.`}</p>
    <p>{`Menu before Borderfall battle.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Inventor`}</li>
        <li parentName="ul">{`Castti: +Rehabilitate, Dancer, +Stimulate +Bewildering Grace`}</li>
        <li parentName="ul">{`Partitio: +Donate BP +Hired Help`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-1"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Throne: +`}{`[1]`}{`A Step Ahead`}</li>
        <li parentName="ul">{`Castti: +`}{`[1]`}{`The Show Goes On +`}{`[2]`}{`A Step Ahead`}</li>
        <li parentName="ul">{`Partitio: +`}{`[2]`}{`Grow on Tree +`}{`[3]`}{`A Step Ahead`}</li>
        <li parentName="ul">{`Osvald: +`}{`[3]`}{`A Step Ahead`}</li>
      </ul>
    </Menu>
    <p>{`Bolderfall battle: Break with Axe / Spear on back, Sword/Axe on front. Or YOLO flee.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If only Partitio needs LP, you can build it by having him HHM x2 both Borderfall and Montwise battles to break the front enemies.`}</p>
    </blockquote>
    <p>{`Pick `}<strong parentName="p">{`Thunder M`}</strong>{`.`}</p>
    <h3 {...{
      "id": "montwise"
    }}>{`Montwise`}</h3>
    <p>{`Optionally purchase `}<strong parentName="p">{`Fire M`}</strong>{` for Montwise battle.`}<br parentName="p"></br>{`
`}{`Mug for `}<strong parentName="p">{`Dazzling Artwork & Stimulating Bracelet`}</strong>{`. Kill with Thunder M.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Item Shop`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell-2"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Dazzling Artwork`}</li>
        <li parentName="ul">{`Sailor's Vest`}</li>
        <li parentName="ul">{`Stimulating Bracelet`}</li>
        <li parentName="ul">{`Octopuff Pot`}</li>
      </ul>
    </Menu>
    <p>{`Stay at `}<strong parentName="p">{`Inn`}</strong>{` if needed.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Need LP on Throne + Partitio now, Castti later.`}</p>
    </blockquote>
    <p>{`Head to `}<strong parentName="p">{`Merry Hills`}</strong>{`.`}</p>
    <p>{`Nothern Montwise Pass battle: can try to skip by walking (38% chance to get battle). If not, handle same as Bolderfall battle.`}</p>
    <h3 {...{
      "id": "western-merry-hills"
    }}>{`Western Merry Hills`}</h3>
    <p>{`Switch to Night at steps.`}</p>
    <ul>
      <li parentName="ul">{`Horned Flies / Winged Serpents: Wind L`}</li>
      <li parentName="ul">{`2 Monkeys: AC back one, Wind L, HHG x3`}</li>
      <li parentName="ul">{`3 Monkeys: AC front one, Wind L, HHG x3`}</li>
      <li parentName="ul">{`Ants: Wind L, Pom M Partitio, AC, HHG x4`}</li>
      <li parentName="ul">{`Antlion + Monkey: AC Antlion, Crit Scope Monkey, Pom M Partitio, HHG x4. Wind L next turn.`}</li>
    </ul>
    <p>{`Walk rest of the screen for 1st attempt. Save at save point, go fight Assassins.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "foreign-assassins"
      }}>{`Foreign Assassins`}</h4>
      <h5 {...{
        "id": "turn-1-2"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: AC x2 Assassin 1`}</li>
        <li parentName="ul">{`Osvald: Springy Boots Partitio`}</li>
        <li parentName="ul">{`Partitio: HHM x2`}</li>
        <li parentName="ul">{`Castti: Rehabilitate Partitio`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`If no Partitio LP, can replace Rehabilitate with Pom L.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-2-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: `}{`[LP]`}{` HHB x4`}</li>
        <li parentName="ul">{`Throne: `}{`[LP]`}{` AC Assassin 4, AC Assassin 2 (Top middle)`}</li>
        <li parentName="ul">{`Osvald: Crit Scope Assassin 1`}</li>
        <li parentName="ul">{`Castti: Defend`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`If you don't get EXPx5 or EXPx100, flee and reload your save.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Castti: BG x4`}</li>
        <li parentName="ul">{`Partitio: `}{`[LP]`}{` HHB x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Winterbloom`}</strong>{`.`}</p>
    <h3 {...{
      "id": "winterbloom-1"
    }}>{`Winterbloom`}</h3>
    <p>{`Start Throne Ch.2`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`Eyeball your money during this menu or during Steals. Need $15000.`}<br parentName="p"></br>{`
`}{`If you have extra money, cut whatever Steals workout best.`}</p>
      </blockquote>
      <h5 {...{
        "id": "learn-skills-1"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: +Collect`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-2"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: +`}{`[1]`}{`Boost Start`}</li>
      </ul>
    </Menu>
    <blockquote>
      <p parentName="blockquote">{`If you used your `}<strong parentName="p">{`Pom L`}</strong>{`, Steal `}<strong parentName="p">{`Red Apple`}</strong>{` in the Tavern`}</p>
    </blockquote>
    <p>{`Steal `}<strong parentName="p">{`Refined Sword & Heavy Coin Pouch`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Knight's Greatbow`}</strong>{`.`}</p>
    <p>{`If under $15000 or no Lily owned, go to `}<strong parentName="p">{`Item Shop`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Lychee S, Silver Hatchet, Horned Helmet`}</strong>{`. `}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-3"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`Lily of the Light if none owned.`}</li>
      </ul>
      <h5 {...{
        "id": "sell-3"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`All Weapons`}</li>
        <li parentName="ul">{`Horned Helmet`}</li>
      </ul>
    </Menu>
    <p>{`Steal `}<strong parentName="p">{`Soldier's Greatbow`}</strong>{`.`}</p>
    <p>{`On next screen, after Ambushes, Steal `}<strong parentName="p">{`Heavy Coin Pouch & Gold Pocket Watch`}</strong>{` from guy guarding house.`}</p>
    <blockquote>
      <h3 parentName="blockquote" {...{
        "id": "latent-management"
      }}>{`Latent Management`}</h3>
      <p parentName="blockquote">{`There's lot's of ways to play it from here, I will list all LP building options here`}</p>
      <ul parentName="blockquote">
        <li parentName="ul">{`Lychee M in chest down-left after Cutscene before last ambush`}</li>
        <li parentName="ul">{`Lychee M Steal in Ch3 Wellgrove`}</li>
        <li parentName="ul">{`Lychee M in Lostseed`}</li>
        <li parentName="ul">{`Lychee L to left of Orphanage in Ch3 Wellgrove`}</li>
        <li parentName="ul">{`Reinforcing Jam in Lostseed`}</li>
      </ul>
      <p parentName="blockquote">{`If everybody needs LP, taking an Inn before Mother might be the best play.`}<br parentName="p"></br>{`
`}{`More commonly, Castti has LP and Partitio & Throne don't, in which case I suggest getting the latter 2 Lychee Ms and the Reinforcing Jam`}<br parentName="p"></br>{`
`}{`There's a Red Apple Steal next to the Reinforcing Jam, which you'll need as well.`}<br parentName="p"></br>{`
`}{`Notes will assume this scenario, but you can cut / add things as needed.`}</p>
    </blockquote>
    <p>{`Run from battle on the way to Bergomi.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "bergomi"
      }}>{`Bergomi`}</h4>
      <ul>
        <li parentName="ul">{`Armor Corrosive + HHB x3`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Wellgrove`}</strong>{`.`}</p>
    <h3 {...{
      "id": "wellgrove-1"
    }}>{`Wellgrove`}</h3>
    <p>{`Start Throne Ch.3`}</p>
    <p>{`Go to `}<strong parentName="p">{`Weapon Shop`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`Need $32000 after this shop`}</p>
      </blockquote>
      <h5 {...{
        "id": "sell-4"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`2 Heavy Coin Pouch`}</li>
        <li parentName="ul">{`Gold Pocket Watch`}</li>
        <li parentName="ul">{`All Weapons`}</li>
      </ul>
    </Menu>
    <p>{`Steal `}<strong parentName="p">{`Wind M & Wind L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Shadow M & Curious Antique`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you don't need the Lychee, can skip and sell Olive L`}</p>
    </blockquote>
    <p>{`Steal `}<strong parentName="p">{`Vivid Jewel & Lychee M`}</strong>{`.`}</p>
    <p>{`Run from battle in Mother's Garden`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "mother-42000hp"
      }}>{`Mother 42000HP`}</h4>
      <h5 {...{
        "id": "turn-1-3"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Attack x2 Mother`}</li>
        <li parentName="ul">{`Osvald: Crit Scope Mother`}</li>
        <li parentName="ul">{`Partitio: Bow Mother`}</li>
        <li parentName="ul">{`Castti: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-3"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Castti: `}{`[LP]`}{` Lily of the Light x3 + Forget-me-do Mother`}</li>
        <li parentName="ul">{`Throne: Armor Corrosive Mother`}</li>
        <li parentName="ul">{`Osvald: Attack x3 `}<strong parentName="li">{`Mother's Aide`}</strong></li>
        <li parentName="ul">{`Partitio: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-1"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: HHB x4`}</li>
        <li parentName="ul">{`Anyone: Shadow M`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Montwise`}</strong>{`.`}</p>
    <h3 {...{
      "id": "montwise-1"
    }}>{`Montwise`}</h3>
    <p>{`Start Throne Ch.3`}</p>
    <p>{`Use Travel Banter to reset steps.`}<br parentName="p"></br>{`
`}{`Run from battle in Abandoned Church.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "father-58000hp-8s-speardaggeraxewindlight"
      }}>{`Father 58000HP 8S (Spear,Dagger,Axe,Wind,Light)`}</h4>
      <h5 {...{
        "id": "turn-1-4"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: AC x2`}</li>
        <li parentName="ul">{`Osvald: Springy Boots Self`}</li>
        <li parentName="ul">{`Partitio: Wind M`}</li>
        <li parentName="ul">{`Castti: Lily + Forget-me-do`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-4"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Elemental Bomb Bottle x3`}</li>
        <li parentName="ul">{`Partitio: HHG x4`}</li>
        <li parentName="ul">{`Others: Pom L Partitio or Defend and do it next turn.`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`If you rolled 0 crits and all low rolls, you might need up to 4 Attacks to fill range. You should NEVER see this though.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-3-2"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Critical Scope`}</li>
        <li parentName="ul">{`Partitio: HHB x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`New Delsta`}</strong>{`.`}</p>
    <h3 {...{
      "id": "lostseed"
    }}>{`Lostseed`}</h3>
    <p>{`Go to `}<strong parentName="p">{`Item Shop`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell-5"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Vivid Jewel`}</li>
        <li parentName="ul">{`Curious Antique`}</li>
        <li parentName="ul">{`Marietta`}</li>
      </ul>
    </Menu>
    <p>{`Pick `}<strong parentName="p">{`Reinforcing Jam`}</strong>{` up the ladder. Steal `}<strong parentName="p">{`Red Apple`}</strong>{` from boy there.`}</p>
    <h3 {...{
      "id": "lostseed-castle"
    }}>{`Lostseed Castle`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Lychee M`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Shadow L`}</strong>{`.`}</p>
    <p>{`You have 2 HHB you can use to clear battles here.`}<br parentName="p"></br>{`
`}{`For Revenant group, break with HHM x3 + Throne Sword x2 + Osvald Attack x2`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`If you have a Thunder Stone, can skip the Job Change. Throne LP AC x2 + Thunder Stone T1.`}</p>
      </blockquote>
      <h5 {...{
        "id": "items"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Get Throne & Partitio to full LP (2 Lychee M one, Reinforcing Jam the other)`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-1"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Inventor`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <blockquote>
        <p parentName="blockquote">{`Kills for Claude are HHB x3 No Crits, HHB x4, 2 L Stone or HHV x3, HHB x4, L Stone (M Stone is very favorable range)`}</p>
      </blockquote>
      <h4 {...{
        "id": "claude-68000hp"
      }}>{`Claude 68000HP`}</h4>
      <h5 {...{
        "id": "turn-1-5"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Springy Boots Self`}</li>
        <li parentName="ul">{`Osvald: Lightning Bolt`}</li>
        <li parentName="ul">{`Partitio: `}{`[LP]`}{` Collect x4`}</li>
        <li parentName="ul">{`Castti: Concoct x2 Darkdelion x2 + Forget-me-do`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Be careful to not use Assassins here!`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-2-5"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: `}{`[LP]`}{` Elemental Bomb Bottle x3, Armor Corrosive`}</li>
        <li parentName="ul">{`Osvald: L Stone`}</li>
        <li parentName="ul">{`Partitio: HHB x3`}</li>
        <li parentName="ul">{`Castti: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Castti: Red Apple Partitio`}</li>
        <li parentName="ul">{`Throne: Crit Scope`}</li>
        <li parentName="ul">{`Partitio: HHB x4`}</li>
        <li parentName="ul">{`Osvald: L Stone`}</li>
      </ul>
    </Battle>
    <p>{`Steal `}<strong parentName="p">{`Key to Freedom`}</strong>{`. 4 Cutscenes then GG!`}</p>
    <h3 {...{
      "id": "changelog"
    }}>{`Changelog`}</h3>
    <h4 {...{
      "id": "3724"
    }}>{`3/7/24`}</h4>
    <ul>
      <li parentName="ul">{`Initial upload`}</li>
      <li parentName="ul">{`Route changed "significantly" from previous routes. Hard to point out exact changes, as there were multiple sets of notes / routes floating around. The big timesave is much better money routing, with the biggest thing being Cape Cold skip.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      